/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cumulative curve's minimum often marks the replication origin in bacteria.`)
};

const es_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mínimo de la curva acumulada a menudo marca el origen de replicación en bacterias.`)
};

const de_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Minimum der kumulativen Kurve markiert bei Bakterien oft den Replikationsursprung.`)
};

const nl_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het minimum van de cumulatieve curve markeert vaak de replicatie-oorsprong bij bacteriën.`)
};

const fr_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le minimum de la courbe cumulée marque souvent l'origine de réplication chez les bactéries.`)
};

const it_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il minimo della curva cumulativa spesso segna l'origine di replicazione nei batteri.`)
};

const pt_br2_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mínimo da curva acumulada frequentemente marca a origem de replicação em bactérias.`)
};

const pt_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mínimo da curva cumulativa marca frequentemente a origem de replicação em bactérias.`)
};

const ja_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累積曲線の最小値は、多くの場合細菌の複製起点を示します。`)
};

const zh_gcskew_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累积曲线的最小值通常标志着细菌的复制起点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_ex2", locale)
	if (locale === "en") return en_gcskew_ex2(inputs)
	if (locale === "es") return es_gcskew_ex2(inputs)
	if (locale === "de") return de_gcskew_ex2(inputs)
	if (locale === "nl") return nl_gcskew_ex2(inputs)
	if (locale === "fr") return fr_gcskew_ex2(inputs)
	if (locale === "it") return it_gcskew_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_ex2(inputs)
	if (locale === "pt") return pt_gcskew_ex2(inputs)
	if (locale === "ja") return ja_gcskew_ex2(inputs)
	return zh_gcskew_ex2(inputs)
};